import React from 'react';
import Navbar from '../components/Navbar.js';
import ConsorcioSection from '../components/ConsorcioSection';
import { Helmet } from 'react-helmet';

export default function Consorcio() {
  return (

    <>
      <Helmet>
        <title>Consorcio | EBM Consultores</title>
        <meta
          name="description"
          content="Consultoría especializada en Empresa Familiar, Gobierno Corporativo y Legado Patrimonial. Descubre cómo acompañamos tu evolución."
        />
      </Helmet>
      <Navbar />
      <ConsorcioSection />
    </>
  );
}
